import { Routes } from '@angular/router';
import { roleGuard } from './guards/role-guard.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: 'process-configuration/data-types/:dataTypeId',
    loadComponent: () =>
      import('./pages/process-data-type/process-data-type.page').then(
        (c) => c.ProcessDataTypePage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'process-configuration/functions/:functionId',
    loadComponent: () =>
      import('./pages/process-function/process-function.page').then(
        (c) => c.ProcessFunctionPage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'process-configuration/messages/:processMessageFormGroupId',
    loadComponent: () =>
      import('./pages/process-message/process-message.page').then(
        (c) => c.ProcessMessagePage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'process-configuration/roles/:processRoleFormGroupId',
    loadComponent: () =>
      import('./pages/process-role/process-role.page').then(
        (c) => c.ProcessRolePage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'process-configuration/services/:processServiceFormGroupId',
    loadComponent: () =>
      import('./pages/process-service/process-service.page').then(
        (c) => c.ProcessServicePage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'process-configuration/user-interfaces/:userInterfaceId',
    loadComponent: () =>
      import('./pages/process-user-interface/process-user-interface.page').then(
        (c) => c.ProcessUserInterfacePage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'process-designs/:processDesignFormGroupId/migrate',
    loadComponent: () =>
      import('./pages/migrate-process-instances/migrate-process-instances.page').then(
        (c) => c.MigrateProcessInstancesPage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'edit-process-design/:designUuid',
    loadComponent: () =>
      import('./pages/edit-process-design/edit-process-design.page').then(
        (c) => c.EditProcessDesignPage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'message-listeners/:messageListenerFormGroupId',
    loadComponent: () =>
      import('./pages/message-listener/message-listener.page').then(
        (c) => c.MessageListenerPage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'process-configuration/data-types',
    loadComponent: () =>
      import('./pages/process-data-types/process-data-types.page').then(
        (c) => c.ProcessDataTypesPage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'process-configuration/functions',
    loadComponent: () =>
      import('./pages/process-functions/process-functions.page').then(
        (c) => c.ProcessFunctionsPage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'process-configuration/messages',
    loadComponent: () =>
      import('./pages/process-messages/process-messages.page').then(
        (c) => c.ProcessMessagesPage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'process-configuration/roles',
    loadComponent: () =>
      import('./pages/process-roles/process-roles.page').then(
        (c) => c.ProcessRolesPage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'process-configuration/services',
    loadComponent: () =>
      import('./pages/process-services/process-services.page').then(
        (c) => c.ProcessServicesPage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'process-configuration/user-interfaces',
    loadComponent: () =>
      import('./pages/process-user-interfaces/process-user-interfaces.page').then(
        (c) => c.ProcessUserInterfacesPage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'process-designs/:processDesignFormGroupId',
    loadComponent: () =>
      import('./pages/process-design/process-design.page').then(
        (c) => c.ProcessDesignPage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'process-instances/:processInstanceFormGroupId',
    loadComponent: () =>
      import('./pages/process-instance/process-instance.page').then(
        (c) => c.ProcessInstancePage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'service-tasks/:serviceTaskFormGroupId',
    loadComponent: () =>
      import('./pages/service-task/service-task.page').then(
        (c) => c.ServiceTaskPage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'tenants/:tenantId',
    loadComponent: () =>
      import('./pages/tenant/tenant.page').then((c) => c.TenantPage),
    pathMatch: 'full',
    canActivate: [roleGuard],
    data: { roles: ['Administrator'] },
  },
  {
    path: 'timers/:timerFormGroupId',
    loadComponent: () =>
      import('./pages/timer/timer.page').then((c) => c.TimerPage),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'tokens/:tokenFormGroupId',
    loadComponent: () =>
      import('./pages/token/token.page').then((c) => c.TokenPage),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'user-tasks/:userTaskFormGroupId',
    loadComponent: () =>
      import('./pages/user-task/user-task.page').then((c) => c.UserTaskPage),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'webhook-deliveries/:webhookDeliveryId',
    loadComponent: () =>
      import('./pages/webhook-delivery/webhook-delivery.page').then(
        (c) => c.WebhookDeliveryPage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
    data: { roles: ['WebhookAdministrator'] },
  },
  {
    path: 'webhook-subscriptions/:webhookSubscriptionId',
    loadComponent: () =>
      import('./pages/webhook-subscription/webhook-subscription.page').then(
        (c) => c.WebhookSubscriptionPage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
    data: { roles: ['WebhookAdministrator'] },
  },
  {
    path: 'home',
    loadComponent: () =>
      import('./pages/home/home.page').then((c) => c.HomePage),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'login',
    loadComponent: () =>
      import('./pages/login/login.page').then((c) => c.LoginPage),
    pathMatch: 'full',
  },
  {
    path: 'not-authorized',
    loadComponent: () =>
      import('./pages/not-authorized/not-authorized.page').then(
        (c) => c.NotAuthorizedPage,
      ),
    pathMatch: 'full',
  },
  {
    path: 'process-administrators',
    loadComponent: () =>
      import('./pages/process-administrators/process-administrators.page').then(
        (c) => c.ProcessAdministratorsPage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'process-configuration',
    loadComponent: () =>
      import('./pages/process-configuration/process-configuration.page').then(
        (c) => c.ProcessConfigurationPage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'process-designs',
    loadComponent: () =>
      import('./pages/process-designs/process-designs.page').then(
        (c) => c.ProcessDesignsPage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'process-instances',
    loadComponent: () =>
      import('./pages/process-instances/process-instances.page').then(
        (c) => c.ProcessInstancesPage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'service-tasks',
    loadComponent: () =>
      import('./pages/service-tasks/service-tasks.page').then(
        (c) => c.ServiceTasksPage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'switch-user',
    loadComponent: () =>
      import('./pages/switch-user/switch-user.page').then(
        (c) => c.SwitchUserPage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'tenants',
    loadComponent: () =>
      import('./pages/tenants/tenants.page').then((c) => c.TenantsPage),
    pathMatch: 'full',
    canActivate: [roleGuard],
    data: { roles: ['Administrator'] },
  },
  {
    path: 'user-activity',
    loadComponent: () =>
      import('./pages/user-activity/user-activity.page').then(
        (c) => c.UserActivityPage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
    data: { roles: ['Administrator'] },
  },
  {
    path: 'user-tasks',
    loadComponent: () =>
      import('./pages/user-tasks/user-tasks.page').then((c) => c.UserTasksPage),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'webhook-deliveries',
    loadComponent: () =>
      import('./pages/webhook-deliveries/webhook-deliveries.page').then(
        (c) => c.WebhookDeliveriesPage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
    data: { roles: ['WebhookAdministrator'] },
  },
  {
    path: 'webhook-subscriptions',
    loadComponent: () =>
      import('./pages/webhook-subscriptions/webhook-subscriptions.page').then(
        (c) => c.WebhookSubscriptionsPage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
    data: { roles: ['WebhookAdministrator'] },
  },
];
